import React, { createContext, useContext, useMemo, useState } from 'react';

type SideBarContext = {
  toggleSideBar: () => void;
  setSideBarOpen: (value: boolean) => void;
  sideBarOpen: boolean;
};

const sideBarContext = createContext<SideBarContext | null>(null);

export const useSideBarContext = () => {
  const context = useContext(sideBarContext);

  if (!context) {
    throw new Error(
      'Cannot use sideBarContext without a sideBarContextProvider.',
    );
  }

  return context;
};

type SideBarContextProviderProps = { children: React.ReactNode };
export const SideBarContextProvider = ({
  children,
}: SideBarContextProviderProps) => {
  const [sideBarOpen, setSideBarOpen] = useState(false);

  const value = useMemo(
    () => ({
      sideBarOpen,
      toggleSideBar: () => setSideBarOpen((current) => !current),
      setSideBarOpen,
    }),
    [sideBarOpen, setSideBarOpen],
  );

  return (
    <sideBarContext.Provider value={value}>{children}</sideBarContext.Provider>
  );
};
